/**
 * Учасники воркспейсу в порядку прототипу v4 (ws.members — порядок членства, власник першим): поточний користувач першим, далі — у порядку,
 * який віддає API (порядок членства). Так упорядковані фільтри й пікери людей. Чиста функція.
 */
export function orderMembers<T extends { user: { id: string } }>(members: readonly T[], meId: string | null | undefined): T[] {
  return [...members.filter((m) => m.user.id === meId), ...members.filter((m) => m.user.id !== meId)];
}
